import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Authenticated = ({ Component }) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth) {
      if (!auth.isAuthenticated && !auth.authLoading) {
        console.log(1);
        navigate('/');
      }
    }
  }, [auth]);

  return <Component />;
};

export default Authenticated;
